import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './styles.css';

function ZoomParallax() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const navigate = useNavigate();

  const images = [
    '/image/hero/image1.jpg',
    '/image/hero/image3.jpg',
    '/image/hero/image4.jpg',
    '/image/hero/image6.jpg',
    '/image/hero/image7.jpg',
    '/image/hero/image8.JPG',
    '/image/hero/image11.jpg'
  ];

  // Précharger les images
  useEffect(() => {
    images.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <section className="hero-section">
      <Carousel
        showThumbs={false}
        showStatus={false}
        infiniteLoop={true}
        autoPlay={false}
        interval={5000}
        transitionTime={800}
        swipeable={true}
        emulateTouch={true}
        showIndicators={true}
        useKeyboardArrows={true}
        dynamicHeight={false}
        renderArrowPrev={(onClickHandler, hasPrev) =>
          hasPrev && (
            <button
              type="button"
              onClick={onClickHandler}
              className={`carousel-arrow carousel-arrow-prev ${isArabic ? 'rtl' : ''}`}
              aria-label={isArabic ? "التالي" : "Previous"}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points={isArabic ? "9 18 15 12 9 6" : "15 18 9 12 15 6"} />
              </svg>
            </button>
          )
        }
        renderArrowNext={(onClickHandler, hasNext) =>
          hasNext && (
            <button
              type="button"
              onClick={onClickHandler}
              className={`carousel-arrow carousel-arrow-next ${isArabic ? 'rtl' : ''}`}
              aria-label={isArabic ? "السابق" : "Next"}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points={isArabic ? "15 18 9 12 15 6" : "9 18 15 12 9 6"} />
              </svg>
            </button>
          )
        }
      >
        {images.map((image, index) => (
          <div key={index} className="carousel-slide">
            <img 
              src={image} 
              alt={isArabic ? `الصورة ${index + 1}` : `Slide ${index + 1}`}
              loading="eager"
              onError={(e) => { 
                console.error(`Failed to load image: ${image}`);
                e.target.src = '/image/hero/image1.jpg'; 
              }}
            />
          </div>
        ))}
      </Carousel>
      
      {/* Contenu fixe par-dessus */}
      <div className="hero-content-fixed">
        <div className="hero-content-box">
          <h1 className="carousel-title">
            {isArabic 
              ? "المنظومة الوطنية للفرصة الجديدة في سوسة و القيروان" 
              : "Dispositif National Nouvelle Chance à Sousse et Kairouan"}
          </h1>
          <p className="carousel-subtitle mb-4">
            {isArabic 
              ? "مرافقة شخصية للنجاح المهني" 
              : "Accompagnement personnalisé pour la réussite professionnelle"}
          </p>
          
          <div className="carousel-buttons">
            <button 
              className="carousel-btn carousel-btn-primary"
              onClick={() => navigate('/registration')}
            >
              {isArabic ? "التسجيل" : "Inscription"}
            </button>
            <button 
              className="carousel-btn carousel-btn-secondary"
              onClick={() => navigate('/contact')}
            >
              {isArabic ? "اتصل بنا" : "Contactez-nous"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ZoomParallax;